import PostItem from './post-item';

export default PostItem;